<template>
    <div class="embed-responsive embed-responsive--16by9">
        <iframe class="embed-responsive__item" :src="url" :title="title" allow="autoplay; fullscreen" allowtransparency="true" scrolling="no" msallowfullscreen></iframe>
    </div>                    
</template>
<script>
export default {
    props: {
        url: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: false
        }
    }
}
</script>